<p-toast />

<p-toast key="has-actions">
  <ng-template let-message #headless let-closeFn="closeFn">
    <div class="flex flex-col gap-3 w-full">
      <section class="flex flex-col p-4 gap-4 w-full">
        <div class="flex items-center gap-5">
          <span class="p-toast-summary">{{ message.summary }}</span>
        </div>
        @if (message?.data?.actions?.length; as len) {
          <div class="flex gap-4 justify-end">
            <div class="flex flex-wrap gap-2 justify-end mt-2">
              @for (action of message.data.actions; track action) {
                <p-button
                  [label]="action.label"
                  [icon]="action.icon"
                  [severity]="action.severity ?? 'primary'"
                  [outlined]="action.outlined ?? false"
                  [size]="action.size ?? 'small'"
                  (onClick)="action.onClick(message); closeFn($event)"
                  />
              }
            </div>
          </div>
        }
      </section>
    </div>
  </ng-template>
</p-toast>
